export default {
    "modal": {
        "login": {
            "title": "Login",
            "userName": "User name",
            "password": "Password",
            "singleSignOn": "Single sign-on",
            "signInWith": "Sign in with..."
        }
    }
};
